import { ErrorContent } from '@bbl-digital/snorre-v2'
import React from 'react'

const PageError: React.FC = () => (
  <div className="flex flex-col h-screen w-full max-w-[500px] mx-auto justify-center items-center">
    <ErrorContent size="xl" text="Ops! Her har det skjedd en feil..." />
  </div>
)

export default PageError
